/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractPaymentFilterByContractsDto } from '../../models/sales-contract-payment-filter-by-contracts-dto';
import { SalesContractPaymentResponseDto } from '../../models/sales-contract-payment-response-dto';

export interface ContractPaymentsControllerFindByContracts$Params {

/**
 * Tenant ID
 */
  tenant: string;
      body: SalesContractPaymentFilterByContractsDto
}

export function contractPaymentsControllerFindByContracts(http: HttpClient, rootUrl: string, params: ContractPaymentsControllerFindByContracts$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesContractPaymentResponseDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, contractPaymentsControllerFindByContracts.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesContractPaymentResponseDto>>;
    })
  );
}

contractPaymentsControllerFindByContracts.PATH = '/o2-sales/contract-payments/{tenant}/by-contracts';
